import { Component, Input, OnInit, ViewChild } from "@angular/core";
import {
  ApexChart,
  ApexAxisChartSeries,
  ChartComponent,
  ApexDataLabels,
  ApexPlotOptions,
  ApexYAxis,
  ApexLegend,
  ApexGrid
} from "ng-apexcharts";
import { MessageService } from 'primeng/api';
import { AdminLogs, UserDetailModel } from "../../Models/Authentication/UserModel";
import { NotificationMessages } from "../../Models/Notifications/NotifiyMessages";
import { AuthService } from "../../Services/auth.service";
import { BaseApiService } from "../../Services/base-api.service";
import { AnlysisInfo } from "../../Models/Session";
import { BaseComponent } from "../../Base/base/base.component";
import { finalize, takeUntil } from "rxjs";


type ApexXAxis = {
  type?: "category" | "datetime" | "numeric";
  categories?: any;
  labels?: {
    style?: {
      colors?: string | string[];
      fontSize?: string;
    };
  };
};

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  yaxis: ApexYAxis;
  xaxis: ApexXAxis;
  grid: ApexGrid;
  colors: string[];
  legend: ApexLegend;
};



@Component({
  selector: 'app-admindash-board',
  templateUrl: './admindash-board.component.html',
  styleUrls: ['./admindash-board.component.css'],standalone:false
})
export class AdmindashBoardComponent extends BaseComponent implements  OnInit {
  @ViewChild("chart") chart!: ChartComponent;
  @Input() Analytic:AnlysisInfo[]=[]
  public chartOptions!: Partial<ChartOptions>;
  loading:boolean=false;
  Users:UserDetailModel[]=[]
  Admins:UserDetailModel[]=[]
  logs:AdminLogs[]=[]
  notifications:NotificationMessages[]=[]
  userid:string=''
  amount:number=0;
  constructor
    (
     private api:BaseApiService,
     private messageService:MessageService,
     private auth:AuthService
    )
  {
    super()
    this.userid=this.auth.getUID();
  }

  getdat(){
    this.loading=true;
    this.api.read("Auth/GetUsersFromAdmin").pipe(
      takeUntil(this.destroy$),
      finalize(() => {
        this.loading = false;
      })

    ).subscribe
    (
        {
          next: (response)=>{
            this.Users  = response;
            this.Admins = this.Users.filter(x=>x.roles==="Administrator")
            this.GetNotifications(this.userid);
            this.GetLogs();
            this.loading=false;
          },
          error:(
            error
          )=>{
            this.loading=false;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
          }
        }
      
    )
  }

  getAmount(){
    this.loading=true;
    this.api.read("Auth/getPaymentsClient1").pipe(
      takeUntil(this.destroy$),
      finalize(() => {
        this.loading = false;
      })
    ).subscribe
    (
      {
        next:(response)=>{
          this.amount= response;
          this.loading=false;
        },
        error:(
          error
        )=>
        {
          this.loading=false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
        }
      }
    )
  }
  GetNotifications(userId:string){
    this.loading=true;
    this.api.read(`Profile_Service/Notifications?userid=${userId}`)
    .pipe
    (
       takeUntil(this.destroy$),
       finalize(() => {
        this.loading = false;
       })
    ).
    subscribe
    (
      {
        next:(response)=>
          {
            this.notifications = response;
            this.loading       = false;
          },
        error:(
          error
        )=>{
  
          this.loading=false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
        }
      }
      
    )
  }

  GetLogs(){
    this.loading=true;
    this.api.read("AdminLogs")
    .pipe(
      takeUntil(this.destroy$),
      finalize(() => {
        this.loading = false;
      })
    ).subscribe
    (
      {
        next:
      (response)=>{
        this.logs     = response;
        if(this.logs.length>0){
          this.chartOptions = {
            series: [
              {
                name: "Values",
                data: [this.Users.length,this.Admins.length,this.notifications.length,this.logs.length,5]
              }
            ],
            chart: {
              height: 350,
              type: "bar",
              events: {
                click: function(chart, w, e) {
                }
              }
            },
            colors: [
              "#008FFB",
              "#00E396",
              "#FEB019",
              "#FF4560",
              "#775DD0",
              "#546E7A",
              "#26a69a",
              "#D10CE8"
            ],
            plotOptions: {
              bar: {
                columnWidth: "45%",
                distributed: true
              }
            },
            dataLabels: {
              enabled: true
            },
            legend: {
              show: false
            },
            grid: {
              show: false
            },
            xaxis: {
              categories:["Users","Admins","Notifications","Logs","Payments"] ,
              labels: {
                style: {
                  colors: [
                    "#008FFB",
                    "#00E396",
                    "#FEB019",
                    "#FF4560",
                    "#775DD0",
                    "#546E7A",
                    "#26a69a",
                    "#D10CE8"
                  ],
                  fontSize: "12px"
                }
              }
            }
          };
        }
        this.loading  = false;
      },
     error:(
        error
      )=>{

        this.loading=false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
      }
     }
    )
    
  }



  ngOnInit()
  {
     this.getAmount();
     this.getdat();
  }


}
